import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consulenzatelefonica',
  templateUrl: './consulenzatelefonica.component.html',
  styleUrls: ['./consulenzatelefonica.component.scss']
})
export class ConsulenzatelefonicaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/consulenzatelefonica/consulenzatelefonica.component.ts